import React from "react";
import { useForm } from "react-hook-form";
import { emailService, GetAllCountry, GetStateByCountry } from "../../lib/api";
import Alert from "@mui/material/Alert";
import { Link } from "react-router-dom";
import { IoIosSend } from "react-icons/io";
import { RouteNavigation } from "../../Routes";

const Enquiry = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const [isChecked, setIsChecked] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [showAlert, setShowAlert] = React.useState(false);
  const [country, setCountry] = React.useState(null);
  const [selectedCountry, setSelectedCountry] = React.useState(null);
  const [stateByCountry, setStateByCountry] = React.useState(null);

  const onSubmit = async (data) => {
    setIsLoading(true);
    const dataResponse = await emailService(data);
    if (dataResponse.status === 200) {
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 5000);
      setIsChecked(false);
      setIsLoading(false);
      reset();
    } else {
      setIsLoading(false);
      reset();
    }
  };

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const GetCountry = await GetAllCountry();
        setCountry(GetCountry?.data);
      } catch (error) {
        throw error;
      }
    };

    fetchData();
  }, []);
  React.useEffect(() => {
    const fetchCountryState = async () => {
      if (selectedCountry) {
        try {
          const GetState = await GetStateByCountry(selectedCountry);
          setStateByCountry(GetState?.data);
        } catch (error) {
          throw error;
        }
      }
    };

    fetchCountryState();
  }, [selectedCountry]);

  return (
    <div className="max-w-[1150px] mx-auto p-4 sm:px-10 md:px-20">
      <h2 className="font-poppins font-semibold text-4xl text-center">
        Enquire Now
      </h2>
      <p className="font-Avenir-book text-lg tracking-wider leading-8 w-full py-5 text-center">
        We're always here to help! Feel free to reach out to us anytime.
      </p>
      <div className="py-5 sm:py-10 max-w-[650px] mx-auto">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <input
                {...register("firstName", { required: true })}
                placeholder="First Name"
                type="text"
                className="bg-[#F9FCFF] border border-[#3362CB] rounded-[16px] p-4 focus:outline-none w-full"
              />
              {errors.firstName && (
                <p className="m-2 text-red-600" role="alert">
                  First name is required
                </p>
              )}
            </div>
            <div>
              <input
                {...register("lastName", { required: true })}
                placeholder="Last Name"
                type="text"
                className="bg-[#F9FCFF] border border-[#3362CB] rounded-[16px] p-4 focus:outline-none w-full"
              />
              {errors.lastName && (
                <p className="m-2 text-red-600" role="alert">
                  Last name is required
                </p>
              )}
            </div>
            <div>
              <input
                {...register("email", { required: true })}
                placeholder="Email"
                type="email"
                className="bg-[#F9FCFF] border border-[#3362CB] rounded-[16px] p-4 focus:outline-none w-full"
              />
              {errors.email && (
                <p className="m-2 text-red-600" role="alert">
                  Email name is required
                </p>
              )}
            </div>
            <div>
              <input
                {...register("number", {
                  required: "Phone number is required",
                  pattern: {
                    value: /^[0-9]*$/,
                    message: "Please enter a valid phone number",
                  },
                })}
                placeholder="Phone Number"
                type="text"
                className="bg-[#F9FCFF] border border-[#3362CB] rounded-[16px] p-4 focus:outline-none w-full"
              />
              {errors.number && (
                <p className="m-2 text-red-600">{errors.number.message}</p>
              )}
            </div>
            <div>
              <select
                {...register("country", {
                  required: true,
                  validate: (value) => value !== "0",
                })}
                defaultValue="0"
                onChange={(e) => setSelectedCountry(e.target.value)}
                placeholder="Country"
                className="bg-[#F9FCFF] border border-[#3362CB] rounded-[16px] p-4 focus:outline-none w-full"
              >
                <option value="0" disabled>
                  Country
                </option>
                {country?.map((countryData) => (
                  <option value={countryData?.countryName}>
                    {countryData?.countryName}
                  </option>
                ))}
              </select>
              {errors.country && (
                <p className="m-2 text-red-600" role="alert">
                  Country is required
                </p>
              )}
            </div>
            <div>
              <select
                {...register("state", {
                  required: true,
                  validate: (value) => value !== "0",
                })}
                defaultValue="0"
                placeholder="State"
                className="bg-[#F9FCFF] border border-[#3362CB] rounded-[16px] p-4 focus:outline-none w-full"
              >
                <option value="0" disabled>
                  State
                </option>
                {stateByCountry?.map((stateData) => (
                  <option value={stateData}>{stateData}</option>
                ))}
              </select>
              {errors.state && (
                <p className="m-2 text-red-600" role="alert">
                  State is required
                </p>
              )}
            </div>
            <div className="col-span-2">
              <input
                {...register("company", { required: true })}
                placeholder="Company Name"
                type="text"
                className="bg-[#F9FCFF] border border-[#3362CB] rounded-[16px] p-4 focus:outline-none w-full"
              />
              {errors.company && (
                <p className="m-2 text-red-600" role="alert">
                  Company name is required
                </p>
              )}
            </div>
            <div className="col-span-2">
              <select
                {...register("subject", {
                  required: true,
                  validate: (value) => value !== "0",
                })}
                defaultValue="0"
                className="bg-[#F9FCFF] border border-[#3362CB] rounded-[16px] p-4 focus:outline-none w-full"
              >
                <option value="0" disabled>
                  Solutions
                </option>
                <option value="Restaurant">Restaurant</option>
                <option value="Bakery">Bakery</option>
                <option value="Van Sales">Van Sales</option>
                <option value="Salon">Salon</option>
                <option value="Fuel Outlet">Fuel Outlet</option>
                <option value="Vegetable Shop">Vegetable Shop</option>
                <option value="Retail Shop">Retail Shop</option>
                <option value="Other">Other</option>
              </select>
              {errors.subject && (
                <p className="m-2 text-red-600" role="alert">
                  Please select a product
                </p>
              )}
            </div>
            <div className="col-span-2">
              <textarea
                {...register("message", {
                  required: "Message your enquiry",
                  minLength: { value: 20, message: "Message too small" },
                })}
                placeholder="Enter Your Message"
                className="bg-[#F9FCFF] border border-[#3362CB] rounded-[16px] p-4 focus:outline-none w-full"
                rows={5}
              />
              {errors.message && (
                <p className="m-2 text-red-600">{errors.message.message}</p>
              )}
            </div>
            <div className="col-span-2 flex gap-2 items-center">
              <input type="checkbox" onClick={() => setIsChecked(!isChecked)} />
              <span>
                By Selecting this you agree to our{" "}
                <Link
                  className="underline text-blue-600"
                  target="_blank"
                  to={RouteNavigation.termsAndConditions}
                >
                  Terms & Conditions
                </Link>
              </span>
            </div>
            <button
              disabled={!isChecked || isLoading}
              className="bg-[#3362CB] text-white py-3 rounded-xl col-span-2 sm:col-span-1 flex items-center justify-center gap-2"
            >
              <IoIosSend size="30px" />
              Submit
            </button>
          </div>
        </form>
        <div className="mt-2">
          {showAlert && (
            <Alert severity="success">
              Your request has been successfully processed.
            </Alert>
          )}
        </div>
      </div>
    </div>
  );
};
export default Enquiry;
